import $ from "jquery";

$(function() {

	let html = ``
	let header = $('.header-main-section').clone()
	let content = $('.layout-content').clone()

		html = `<table class="report-container">
		<thead class="report-header">
			<tr>
					<th class="report-header-cell">
						<div class="header-info">
							<header role="banner">
								<div class="header-main-section">
								</div>
							</header>
						</div>
					</th>
				</tr>
			</thead>
			<tbody class="report-content">
				<tr>
					<td class="report-content-cell">
								<main role="main">

									<div class="layout-content">
										
									</div>

								</main>
						</td>
				</tr>
			</tbody>
	</table>`

	$('body .dialog-off-canvas-main-canvas').append(html)

	$(header).appendTo('table.report-container .header-main-section')
	$(content).appendTo('tbody.report-content tr td .layout-content')
	

	$('.btn__project-download').on('click', function(e) {  
		window.print();
	})

});